import { cx } from "@jugl-web/utils";
import { parseChatMarkdown } from "@jugl-web/domain-resources/chat-bot/utils/parseChatMarkdown";
import React from "react";
import { Avatar } from "@jugl-web/ui-components";
import { ChatBotPreviewMessage } from "../../types";
import { ChatBotPreviewTheme } from "../../consts";

export const ChatBotPreviewMessageBubble: React.FC<{
  message: ChatBotPreviewMessage;
  showAvatar: boolean;
  theme: ChatBotPreviewTheme;
}> = ({ message, showAvatar, theme }) => (
  <div
    className={cx(
      "flex items-end gap-1",
      message.isOutgoing && "flex-row-reverse"
    )}
  >
    {showAvatar && <Avatar username="" size="sm" imageUrl={message.avatar} />}
    <div
      className={cx(
        "mt-6 flex w-max max-w-[240px] flex-col gap-[5px] rounded-2xl p-4",
        message.isOutgoing
          ? cx("bg-primary ml-auto rounded-br-none", theme.outgoingBg)
          : cx("bg-grey-100 rounded-bl-none", theme.incomingBg)
      )}
    >
      <span
        className={cx(
          "font-secondary truncate text-sm font-medium leading-[140%]",
          message.isOutgoing ? theme.outgoingNickColor : "text-dark-600"
        )}
      >
        {message.username}
      </span>
      <span
        className={cx(
          "font-secondary whitespace-pre-wrap break-words text-sm leading-[140%]",
          message.isOutgoing ? theme.outgoingTextColor : "text-dark"
        )}
      >
        {parseChatMarkdown({ raws: message.text })}
      </span>
    </div>
  </div>
);
